export default __webpack_public_path__ + "static/media/mobikwik.c412ec44.webp";